// Whether this user is in the redesign experience. The redesign graduated from a beta cohort (the
// `redesignBeta` auth group) to the DEFAULT: it is served in place at the existing URLs (each mapped
// legacy page renders the redesign component), so everyone gets it and this always returns true. Kept
// as a hook because a couple of redesign features gate on it (e.g. the after-login publisher settings
// modal); to re-gate the redesign behind a cohort, restore the group / override check here.
export const useIsRedesignCohort = () => true;
